export default __webpack_public_path__ + "static/media/pesolatino.aea39d1d.jpeg";